// src/pages/apps/calendar/Calendar.tsx

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { EventClickArg } from '@fullcalendar/core';
import CalendarAddNewEventModal from 'components/modals/CalendarAddNewEventModal';
import CalendarProvider, { useCalendarContext } from 'providers/CalendarProvider';
import CalendarTop from './CalendarTop';
import CalendarHeader from './CalendarHeader';
import CalendarEventModal from 'components/modals/CalendarEventModal';
import { HANDLE_SELECT, SET_CALENDAR_STATE } from 'reducers/CalendarReducer';
import FullCalendar from 'components/base/FullCalendar';
import { Evento } from 'data/calendarEvents';
import esLocale from '@fullcalendar/core/locales/es';

const index = () => {
  return (
    <CalendarProvider>
      <Calendar />
    </CalendarProvider>
  );
};

const Calendar = () => {
  const { calendarDispatch } = useCalendarContext();
  const [events, setEvents] = useState<Evento[]>([]);
  
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:2000';

  useEffect(() => {
    const fetchEventos = async () => {
      try {
        const response = await axios.get(`${apiUrl}/eventos`);
        
        // Formateamos la respuesta para cumplir con la interfaz Evento
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        
        const formattedEvents: Evento[] = response.data.map((evento: Evento) => ({
          ...evento,                  // Traemos todos los campos de tu BD
          id: String(evento.id),      // Aseguramos que el ID sea string
          title: evento.descripcion || 'Sin título', // Asignamos el title para FullCalendar
          className: 'text-primary'   // Estilo por defecto de la plantilla
        }));
        
        setEvents(formattedEvents);
      } catch (error) {
        console.error('Error fetching eventos:', error);
      }
    };

    fetchEventos();
  }, [apiUrl]);

  const handleEventClick = (info: EventClickArg) => {
    // Al usar una sola interfaz, toda tu info de BD está directamente en info.event.extendedProps
    calendarDispatch({
      type: SET_CALENDAR_STATE,
      payload: {
        selectedEvent: info.event
      }
    });
  };

  return (
    <div>
      <CalendarTop />
      <CalendarHeader />
      <div className="mt-6 mb-9">
        <FullCalendar
          height={800}
          locale={esLocale} 
          select={info => {
            calendarDispatch({
              type: HANDLE_SELECT,
              payload: info
            });
          }}
          events={events} // Pasamos los eventos mapeados
          eventClick={handleEventClick}
        />
      </div>
      <CalendarEventModal />
      <CalendarAddNewEventModal />
    </div>
  );
};

export default index;